import React from 'react';
import { itemFilterTypes } from '../../../constants';
import FilterGroup from './filter-group';

const ContentCpdCategoryFilterGroup = ({ onApply }) => {
  const activeFilters = [
    itemFilterTypes.contentType,
    itemFilterTypes.contentLength,
    itemFilterTypes.bookmark,
  ]

  return <span id='content-cpd-category-filter-group'>
    <FilterGroup {...{
      activeFilters,
      onApply
    }} />
  </span>
}

export default ContentCpdCategoryFilterGroup


// WEBPACK FOOTER //
// ./src/containers/components/filters/content-cpd-category-filter-group.js